import { useState, useEffect } from "react";
import { authActivityEvents } from "../services/authActitivityEvents";

const useAuthEvents = () => {
    // const [kpiSummary, setKpiSummary] = useState(null);
    // const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [timelineMode, setTimelineMode] = useState("hours")
    const [timeline, setTimeline] = useState([]);
    const [timelineLoading, setTimelineLoading] = useState(true);

    // const fetchKPISummary = async () => {
    //     try {
    //         setLoading(true);
    //         const data = await authActivityEvents.kpiSummary("kpi-summary");
    //         setKpiSummary(data);
    //         setError(null);
    //     } catch (err) {
    //         console.error(err);
    //         setError("Failed to load KPI summary");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     fetchKPISummary();
    // }, []);

    const fetchTimeline = async () => {
        try {
            setTimelineLoading(true);
            const data = await authActivityEvents.getThreatTimeline();
            // console.log("this is hhhhhhhhhhhhh",data);

            setTimelineLoading(data.mode)
            // Transform data for chart
            const formatted = (data?.data?.points ?? []).map((item) => ({
                time: new Date(item?.recorded_at ?? Date()),
                threat: item?.current_threat_score ?? 0,
                total: item?.total_events ?? 0,
                critical: item?.critical_events ?? 0,
                highRisk: item?.high_risk_events ?? 0,
            }));
            setTimeline(formatted);
        } catch (err) {
            console.error("Timeline error:", err);
        } finally {
            setTimelineLoading(false);
        }
    };

    useEffect(() => {
        // fetchKPISummary();
        fetchTimeline();
    }, []);


    return {
        // kpiSummary,
        // loading,
        error,
        // refresh: fetchKPISummary,

        timeline,
        timelineMode,
        timelineLoading,
    };
};

export { useAuthEvents };